export const MAX_FILE_SIZE_IN_GB = 5;
export const FILES_LIMIT = 1;
export const CONTENT_FORMATS = '.mp3,.mp4,.mov';
export const REGEX_URL = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
